import axios from "axios";

// TODO: Consider move this logic back to Rosetta
export async function enableAutoRenew(subscriptionId: string) {
  const response = await axios.post<{ code: number; data: boolean }>(`/piano/renew`, {
    subscriptionId,
  });
  const { code, data } = response.data;

  return code === 0 && data === true;
}
